// Detecção de ambiente (painel-adm-taua#126) -- VUE_APP_ENV é injetada só no
// build de homologação (build-hmg.yaml), assada no bundle no momento do
// build (Vue CLI/webpack, não runtime) -- mesmo padrão já usado por
// VUE_APP_API_URL. O build de produção (build.yaml) nunca define essa
// variável, então isHomolog fica false por padrão/omissão.
export const isHomolog = process.env.VUE_APP_ENV === 'hmg'
